import { reducer as vehiclesReducer } from './slice';

export * from './actions';
// export * from './middlewares';

export default vehiclesReducer;
